module.exports = __webpack_public_path__ + "static/media/users.30d372c0.svg";